/** Preserve taxonomy order, promote orphans and terminate malformed cycles. */
export function sectionRows(sections) {
  const byId = new Map(sections.map(section => [section.id, section]));
  const children = new Map(), roots = [];
  sections.forEach(section => {
    if (section.parentId && section.parentId !== section.id && byId.has(section.parentId)) {
      if (!children.has(section.parentId)) children.set(section.parentId, []);
      children.get(section.parentId).push(section);
    } else roots.push(section);
  });
  const seen = new Set(), rows = [];
  function visit(root) {
    const stack = [{ section: root, depth: 0, parentTitle: '' }];
    while (stack.length) {
      const current = stack.pop(), { section } = current;
      if (seen.has(section.id)) continue;
      seen.add(section.id);
      const nested = children.get(section.id) || [];
      rows.push({ ...current, childCount: nested.length });
      for (let index = nested.length - 1; index >= 0; index--) stack.push({ section: nested[index], depth: current.depth + 1, parentTitle: section.title });
    }
  }
  roots.forEach(visit);
  sections.forEach(section => { if (!seen.has(section.id)) visit(section); });
  return rows;
}
